<ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>

@if (!isLoading) {
  <div>
    <ziro-breadcrumbs [labelParam]="licenseTier">
      <ziro-breadcrumb-card-item>
        @if (unusedDevicesReport?.numCalls === 0) {
          <div
            [innerHTML]="'tkey;reports.cucm_license_optimizer.overview.description.export_disabled' | escapeHtml"
          ></div>
        }
        @if (unusedDevicesReport?.numCalls !== 0) {
          <div>
            <div
              [innerHTML]="'tkey;reports.cucm_license_optimizer.overview.description.export_enabled' | escapeHtml"
            ></div>
            <p class="mb-0">
              <a [routerLink]="[]" (click)="onGetFileClicked()">
                {{ 'tkey;reports.xlsx_export.button' | translate }}
              </a>
              <span
                [innerHTML]="
                  'tkey;reports.cucm_license_optimizer.overview.description.export_enabled.part_two' | escapeHtml
                "
              ></span>
            </p>
          </div>
        }
      </ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>
    @if (unusedDevicesReport?.numCalls === 0) {
      <div class="ziro-page-alert alert border-warning w-100 mt-1" data-automation="device-utilization-no-cdrs-warning">
        <i [ngClass]="ziroIcons.WARNING_TRIANGLE" class="text-warning fa-4x"></i>
        <div class="ms-3" [innerHTML]="'tkey;reports.cucm_license_optimizer.no_cdr.message' | escapeHtml"></div>
      </div>
    }
    @if (unusedDevicesReport?.numCalls > 0) {
      <ziro-datatable
        [class]="'ziro-card'"
        class="license-optimization-datatable"
        [columns]="columns"
        [noResultsAlert]="'tkey;reports.cucm_license_optimizer.no_cdr.message'"
        [rowDataSource]="tableRows"
        [uniqueRowIdentifier]="'type'"
        [dataAutomation]="'license-optimization-datatable'"
      ></ziro-datatable>
    }
  </div>
}
